import React from 'react';
import cx from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { ChatIcon, CommitteeIcon, ContactIcon, ProfileIcon } from '../assets/icons';
import { ROUTES_MAPPING } from '../utils/constants';
import useAuth from '../hooks/useAuth';

import styles from './Footer.module.css';

const Footer = () => {
  const { pathname } = useLocation();
  const { isAdmin } = useAuth();

  return (
    <div className={styles.container}>
      <Link to={ROUTES_MAPPING.contacts} className={cx(styles.footerItem, {[styles.active]: pathname === ROUTES_MAPPING.contacts})}>
        <ContactIcon className={styles.icon} />
        Contacts
      </Link>
      <Link to={ROUTES_MAPPING.committee} className={cx(styles.footerItem, {[styles.active]: pathname === ROUTES_MAPPING.committee})}>
        <CommitteeIcon className={styles.icon} />
        Committee
      </Link>
      <Link to={ROUTES_MAPPING.announcements} className={cx(styles.footerItem, {[styles.active]: pathname === ROUTES_MAPPING.announcements})}>
        <ChatIcon className={styles.icon} />
        Updates
      </Link>
      {isAdmin ? (
        <Link to={ROUTES_MAPPING.admin} className={cx(styles.footerItem, {[styles.active]: pathname === ROUTES_MAPPING.admin})}>
          <ProfileIcon className={styles.icon} />
          Admin
        </Link>
      ) : null}
    </div>
  );
};

export default Footer;
